import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import UPLOAD_GALLERY_ICON from '../../../Assets/Images/aggrementPdf1.png';
import { ADD_SIGN_CONTRACTS_ACTION, GET_SIGN_CONTRACTS_ACTION, UPDATE_SIGN_CONTRACTS_ACTION } from '../../../Redux/Slices/ContentSlice/Content.action';
import Constant from '../../../Utils/Constant';
import Skeleton from 'react-loading-skeleton';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import TableContainer from '../../../Components/TableContainer/TableContainer';
const ReviewSignContracts = () => {
  const dispatch = useDispatch();
  const [agreementIds, setAgreementIds] = useState({
    Confidentiality_Agreement: null,
    Code_of_Ethics_and_Conducts: null,
    Service_Agreement: null,
  });
  const [ConfidentialityAgreementFile, setConfidentialityAgreementFile] = useState(null);
  const [ConfidentialityAgreementPrev, setConfidentialityAgreementPrev] = useState(null);
  const [NonCompeteAgreementFile, setNonCompeteAgreementFile] = useState(null);
  const [NonCompeteAgreementPrev, setNonCompeteAgreementPrev] = useState(null);
  const [InterpreterContractAgreementFile, setInterpreterContractAgreementFile] = useState(null);
  const [InterpreterContractAgreementPrev, setInterpreterContractAgreementPrev] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [signContractsList, setSignContractsList] = useState([]);
  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No.",
      minWidth: 100,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      hideOnMobile: true,
    },
    {
      hideOnMobile: true,
      field: "profile_img",
      headerName: "Profile",
      minWidth: 50,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params?.row?.content ? (
          <PictureAsPdfIcon sx={{ fontSize: "30px", width: '30px', textAlign: 'center' }} />
        ) : (
          <PictureAsPdfIcon sx={{ fontSize: "30px", width: '30px', textAlign: 'center' }} />
        );
      },
    },
    {
      field: "agreement",
      headerName: "Agreement",
      minWidth: 250,
      filterable: true,
      sortable: true,
      flex: 1,
      renderCell: (params) => params?.row?.agreement?.split('_').join(" ")
    },
    {
      field: "action",
      headerName: "Download",
      minWidth: 50,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const { id, status } = params?.row;
        const isBlocked = status === -1;
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <Tooltip title={"Download"}>
              <IconButton
                // onClick={() => handleAccountStatusChange(id, isBlocked ? 1 : -1)}
                sx={{
                  backgroundColor: "#f44336",
                  width: "30px",
                  height: "30px",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#d32f2f",
                  },
                }}
                onClick={() => {
                  handleViewPdf(params?.row?.media)
                }}
              >
                <ArrowDownwardIcon sx={{
                  color: '#fff'
                }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  const handleFileChange = async (file, type) => {
    if (file) {
      if (file.size <= 5 * 1024 * 1024) {
        if (file.type === 'application/pdf') {
          const formData = new FormData();
          const agreementId = agreementIds[type];
          console.log('agreementId', agreementId);
          if (agreementId) {
            formData.append('agreement', type);
            formData.append('media', file);
            await dispatch(UPDATE_SIGN_CONTRACTS_ACTION({ formData, agreementId })).unwrap()
              .then((res) => {
                if (res?.s === 1) {
                  toast.success(`${type} Agreement successfully updated!`);
                  getAllSignContractsList();
                } else {
                  toast.error(`Error while updating ${type} Agreement`);
                }
              }).catch((error) => {
                toast.error(error);
              });
          } else {
            formData.append('agreement', type);
            formData.append('media', file);
            await dispatch(ADD_SIGN_CONTRACTS_ACTION({ formData })).unwrap()
              .then((res) => {
                if (res?.s === 1) {
                  toast.success(`${type} Agreement successfully uploaded!`);
                  getAllSignContractsList();
                } else {
                  toast.error(`Error while uploading ${type} Agreement`);
                }
              }).catch((error) => {
                toast.error(error);
              });
          }
        } else {
          toast.error('Please upload a valid PDF file');
        }
      } else {
        toast.error('File size exceeds the limit of 5MB');
      }
    }
  };
  const handleViewPdf = (file) => {
    if (file) {
      const fileUrl = `${Constant?.BASE_URL}/${file}`;
      window.open(fileUrl, "_blank");
    } else {
      toast.error("No PDF file selected");
    }
  };
  const getAllSignContractsList = async () => {
    setIsLoading(true);
    await dispatch(GET_SIGN_CONTRACTS_ACTION()).unwrap()
      .then((res) => {
        if (res && res?.s === 1) {
          const Rowdata = res?.r?.filter((elem) => elem?.status === 1)?.map((data, i) => ({
            rowid: i + 1,
            ...data,
          }));
          if (Rowdata?.length > 0) {
            Rowdata.forEach((contract) => {
              switch (contract?.agreement) {
                case "Confidentiality_Agreement":
                  setAgreementIds((prevState) => ({ ...prevState, Confidentiality_Agreement: contract?.id }));
                  setConfidentialityAgreementPrev(`${Constant.BASE_URL}${contract?.media}`);
                  break;
                case "Service_Agreement":
                  setAgreementIds((prevState) => ({ ...prevState, Service_Agreement: contract?.id }));
                  setInterpreterContractAgreementPrev(`${Constant.BASE_URL}${contract?.media}`);
                  break;
                case "Code_of_Ethics_and_Conducts":
                  setAgreementIds((prevState) => ({ ...prevState, Code_of_Ethics_and_Conducts: contract?.id }));
                  setNonCompeteAgreementPrev(`${Constant.BASE_URL}${contract?.media}`);
                  break;
                default:
                  break;
              }
            });
          }
          setIsLoading(false);
          setSignContractsList(Rowdata);
        }
        setIsLoading(false);
      }).catch((error) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getAllSignContractsList();
  }, []);
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4}>
          <Grid container spacing={3}>
            {/* Confidentiality Agreement */}
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "100%",
                  height: "100px",
                  overflow: "hidden",
                  background: "#F4F4F4",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: '10px'
                }}
              >
                {!ConfidentialityAgreementPrev ? (
                  <label htmlFor="cover-upload1">
                    <Button
                      component="span"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        outline: "none",
                        border: "none",
                        backgroundColor: "transparent",
                        textTransform: "capitalize",
                      }}
                    >
                      <img
                        src={UPLOAD_GALLERY_ICON}
                        alt="Upload Icon"
                        width={"42px"}
                      />
                      <Typography variant="body2" sx={{
                        fontSize: "14px", fontWeight: "600",
                        display: 'flex',
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}>
                        Confidentiality Agreement
                        <span style={{ color: "rgb(221, 221, 221)" }}>(Click here to upload PDF)</span>
                      </Typography>
                      <input
                        accept="application/pdf"
                        style={{ display: "none" }}
                        id="cover-upload1"
                        type="file"
                        onChange={(e) => handleFileChange(e.target.files[0], 'Confidentiality_Agreement')}
                      />
                    </Button>
                  </label>
                ) : (
                  <Box>
                    <Box sx={{
                      textAlign: 'center',

                    }}>
                      <PictureAsPdfIcon sx={{ fontSize: '50px' }} />
                      <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "600", fontFamily: 'Outfit', }}>
                        Update Confidentiality Agreement

                      </Typography>
                    </Box>
                    <IconButton
                      component="span"
                      sx={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "16px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        position: "absolute",
                        right: "10px",
                        top: "5px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setConfidentialityAgreementFile(null);
                        setConfidentialityAgreementPrev(null);
                      }}
                    >
                      <CloseIcon sx={{ color: "red", fontSize: "26px" }} />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Grid>

            {/* Non-Compete Agreement */}
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "100%",
                  height: "100px",
                  overflow: "hidden",
                  background: "#F4F4F4",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: '10px'
                }}
              >
                {!NonCompeteAgreementPrev ? (
                  <label htmlFor="cover-upload2">
                    <Button
                      component="span"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        outline: "none",
                        border: "none",
                        backgroundColor: "transparent",
                        textTransform: "capitalize",
                      }}
                    >
                      <img
                        src={UPLOAD_GALLERY_ICON}
                        alt="Upload Icon"
                        width={"42px"}
                      />
                      <Typography variant="body2" sx={{
                        fontSize: "14px", fontWeight: "600", display: 'flex',
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}>
                        Code of Ethics and Conducts
                        <span style={{ color: "rgb(221, 221, 221)" }}>(Click here to upload PDF)</span>
                      </Typography>
                      <input
                        accept="application/pdf"
                        style={{ display: "none" }}
                        id="cover-upload2"
                        type="file"
                        onChange={(e) => handleFileChange(e.target.files[0], 'Code_of_Ethics_and_Conducts')}
                      />
                    </Button>
                  </label>
                ) : (
                  <Box>
                    <Box sx={{
                      textAlign: 'center',

                    }}>
                      <PictureAsPdfIcon sx={{ fontSize: '50px' }} />
                      <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "600", fontFamily: 'Outfit', }}>
                        Update Code of Ethics and Conducts
                      </Typography>
                    </Box>
                    <IconButton
                      component="span"
                      sx={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "16px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        position: "absolute",
                        right: "10px",
                        top: "5px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setNonCompeteAgreementFile(null);
                        setNonCompeteAgreementPrev(null);
                      }}
                    >
                      <CloseIcon sx={{ color: "red", fontSize: "26px" }} />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Grid>

            {/* Interpreter Contract Agreement */}
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "100%",
                  height: "100px",
                  overflow: "hidden",
                  background: "#F4F4F4",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: '10px'
                }}
              >
                {!InterpreterContractAgreementPrev ? (
                  <label htmlFor="cover-upload3">
                    <Button
                      component="span"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        outline: "none",
                        border: "none",
                        backgroundColor: "transparent",
                        textTransform: "capitalize",
                      }}
                    >
                      <img
                        src={UPLOAD_GALLERY_ICON}
                        alt="Upload Icon"
                        width={"42px"}
                      />
                      <Typography variant="body2" sx={{
                        fontSize: "14px", fontWeight: "600", display: 'flex',
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}>
                        Service Agreement
                        <span style={{ color: "rgb(221, 221, 221)" }}>(Click here to upload PDF)</span>
                      </Typography>
                      <input
                        accept="application/pdf"
                        style={{ display: "none" }}
                        id="cover-upload3"
                        type="file"
                        onChange={(e) => handleFileChange(e.target.files[0], 'Service_Agreement')}
                      />
                    </Button>
                  </label>
                ) : (
                  <Box>
                    <Box sx={{
                      textAlign: 'center',

                    }}>
                      <PictureAsPdfIcon sx={{ fontSize: '50px' }} />
                      <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "600", fontFamily: 'Outfit', }}>
                        Update Service Agreement
                      </Typography>
                    </Box>
                    <IconButton
                      component="span"
                      sx={{
                        width: "25px",
                        height: "25px",
                        borderRadius: "16px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                        position: "absolute",
                        right: "10px",
                        top: "5px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setInterpreterContractAgreementFile(null);
                        setInterpreterContractAgreementPrev(null);
                      }}
                    >
                      <CloseIcon sx={{ color: "red", fontSize: "26px" }} />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <Box sx={{
            height: '400px',
            overflowY: "auto",
            padding: '10px 0px'
          }}>
            <TableContainer
              rows={signContractsList}
              columns={columns}
              loading={isLoading}
              paginationShow={false}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReviewSignContracts;

